/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Col_MedianInputs */

const en_salary_col_median = /** @type {(inputs: Salary_Col_MedianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Median`)
};

const de_salary_col_median = /** @type {(inputs: Salary_Col_MedianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Median`)
};

const fr_salary_col_median = /** @type {(inputs: Salary_Col_MedianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médian`)
};

const es_salary_col_median = /** @type {(inputs: Salary_Col_MedianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediana`)
};

const it_salary_col_median = /** @type {(inputs: Salary_Col_MedianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediana`)
};

const nl_salary_col_median = /** @type {(inputs: Salary_Col_MedianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediaan`)
};

const pl_salary_col_median = /** @type {(inputs: Salary_Col_MedianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediana`)
};

const fi_salary_col_median = /** @type {(inputs: Salary_Col_MedianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediaani`)
};

const da_salary_col_median = /** @type {(inputs: Salary_Col_MedianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Median`)
};

const sv_salary_col_median = /** @type {(inputs: Salary_Col_MedianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Median`)
};

/**
* | output |
* | --- |
* | "Median" |
*
* @param {Salary_Col_MedianInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_col_median = /** @type {((inputs?: Salary_Col_MedianInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Col_MedianInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_col_median(inputs)
	if (locale === "fr") return fr_salary_col_median(inputs)
	if (locale === "es") return es_salary_col_median(inputs)
	if (locale === "it") return it_salary_col_median(inputs)
	if (locale === "nl") return nl_salary_col_median(inputs)
	if (locale === "pl") return pl_salary_col_median(inputs)
	if (locale === "fi") return fi_salary_col_median(inputs)
	if (locale === "da") return da_salary_col_median(inputs)
	if (locale === "sv") return sv_salary_col_median(inputs)
	return en_salary_col_median(inputs)
});